import { useNavigate } from 'react-router-dom'
import useProductCategories from '../../hooks/useProductCategories'
export default function CategoriesGrid() {
  const navigate = useNavigate()
  const { categories } = useProductCategories()

  return (
    <div className="grid grid-cols-3 gap-4">
      {categories.map(({ categorySlug, name, iconUrl }) => (
        <div
          key={categorySlug}
          onClick={() => navigate(`/categories/${categorySlug}`)}
          className="flex flex-col items-center flex-1 bg-background p-4 rounded-lg shadow cursor-pointer hover:shadow-lg transition-shadow duration-200"
        >
          <div className="bg-[#EDDDC9] rounded-[4.12px] overflow-hidden flex items-center justify-center">
            <img
              src={iconUrl}
              alt={name}
              className="w-full h-auto object-contain rounded-[5.12px]"
            />
          </div>
          <span className="mt-2 text-sm font-bold text-center font-inter">{name}</span>
        </div>
      ))}
    </div>
  )
}
